import { jsx as a } from "react/jsx-runtime";
import { c as b } from "react/compiler-runtime";
import { Tabs as p } from "@mui/material";
function S(m) {
  const e = b(13);
  let o, t, r, i;
  e[0] !== m ? ({
    children: o,
    divider: i,
    sx: r,
    ...t
  } = m, e[0] = m, e[1] = o, e[2] = t, e[3] = r, e[4] = i) : (o = e[1], t = e[2], r = e[3], i = e[4]);
  const c = i === void 0 ? !1 : i;
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = {
    borderBottom: 1,
    borderColor: "divider"
  }, e[5] = s) : s = e[5];
  const f = s;
  let l;
  e[6] !== c || e[7] !== r ? (l = c ? Array.isArray(r) ? [f, ...r] : r ? [f, r] : f : r, e[6] = c, e[7] = r, e[8] = l) : l = e[8];
  const n = l;
  let d;
  return e[9] !== o || e[10] !== n || e[11] !== t ? (d = /* @__PURE__ */ a(p, { ...t, sx: n, children: o }), e[9] = o, e[10] = n, e[11] = t, e[12] = d) : d = e[12], d;
}
export {
  S as Tabs
};
